import React, { Children } from 'react';
import PropTypes from 'prop-types';

HeroCardGroup.propTypes = {
  children: PropTypes.node
};

export default function HeroCardGroup(props) {
  const { children } = props;

  return (
    <div className="max-w-screen-xl mx-auto flex gap-3 w-full flex-col md:flex-row md:items-stretch">
      {Children.map(children, (child) => (
        <div className="w-full md:flex-1 md:min-w-0">{child}</div>
      ))}
    </div>
  );
}
